module.exports = __webpack_public_path__ + "static/media/cassette-tape.867521d2.svg";